import { render, staticRenderFns } from "./CodeRulesTable.vue?vue&type=template&id=65c07fd8&"
import script from "./CodeRulesTable.vue?vue&type=script&lang=js&"
export * from "./CodeRulesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\el-dynamic-form-design\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65c07fd8')) {
      api.createRecord('65c07fd8', component.options)
    } else {
      api.reload('65c07fd8', component.options)
    }
    module.hot.accept("./CodeRulesTable.vue?vue&type=template&id=65c07fd8&", function () {
      api.rerender('65c07fd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/render/CodeRulesTable.vue"
export default component.exports